import { Component, Input, OnInit, Output, ViewChild,EventEmitter } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';


@Component({
  selector: 'app-monthly-chart',
  templateUrl: './monthly-chart.component.html',
  styleUrls: ['./monthly-chart.component.scss']
})
export class MonthlyChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  @Input() chartOptions: any;
  @Input() loading: boolean;

  @Output() optionSelected = new EventEmitter();

  option = [
    {
      value: 'device',
      type: 'Số lượng loa',
    },
    {
      value: 'order',
      type: 'Đơn hàng',
    },
    {
      value: 'customer',
      type: 'Khách hàng',
    },
    {
      value: 'workspace',
      type: 'Cửa hàng',
    }
  ];

  selected = {
    value: 'device',
    type: 'Số lượng loa',
  };

  selectOption(event: Event, value: string, type: string) {
    event.preventDefault();
    this.selected = {
      value: value,
      type : type
    }
    this.optionSelected.emit(this.selected);
  }
  constructor() {
  }

  ngOnInit(): void {
  }
}
